// BodyFatTable.js
import React from 'react';
function BodyFatTable({ result }) {
  return (
    <div>
      <div>
        <table >
          <thead>
            <tr>
              <th >Status</th>
              <th >Persentase</th>
            </tr>
          </thead>
          <tbody>
            <tr >
              <td>Persentase Lemak:</td>
              <td>{result.bodyFatPercentage} %</td>
            </tr>
            <tr >
               <td>    Massa Lemak</td>
               <td>{result.fatMass} kg</td>
             </tr>
            <tr >
               <td>Massa Otot Bersih</td>
               <td>{result.leanMass} kg</td>
             </tr>
            <tr >
               <td>Klasifikasi Lemak Tubuh</td>
               <td>{result.bodyFatCategory}</td>
             </tr>
            {result.idealBodyFatPercentage !== 0 && (
              <>
                <tr>
                   <td>Persentase Lemak Tubuh Ideal:</td>
                   <td>{result.idealBodyFatPercentage} %</td>
                 </tr>
                 <tr>
                   <td>Lemak yang Perlu Dihilangkan untuk Mencapai Tingkat Ideal:</td>
                   <td>{result.bodyFatToLose} kg</td>
                 </tr>
              </>
            )}
          </tbody>
        </table>
      </div>
        <br />
        <hr />
        <div>
          <table >
            <thead>
              <tr>
                <th >Klasifikasi</th>
                <th >Laki-laki</th>
                <th >Perempuan</th>
              </tr>
            </thead>
            <tbody>
              <tr className={result.bodyFatCategory === 'Lemak Esensial' ? 'highlightedOk' : ''}>
                <td>Lemak Esensial (Essential Fat)</td>
                <td>2-5%</td>
                <td>10-13%</td>
              </tr>
              <tr className={result.bodyFatCategory === 'Atlet' ? 'highlightedOk' : ''}>
                <td>Atlet (Athletes)</td>
                 <td>    6-13%</td>
                 <td>14-20%</td>
               </tr>
              <tr className={result.bodyFatCategory === 'Kebugaran' ? 'highlightedOk' : ''}>
                 <td> Kebugaran (Fitness)</td>
                 <td>14-17%</td>
                 <td>21-24%</td>
               </tr>
              <tr className={result.bodyFatCategory === 'Dapat Diterima' ? 'highlightedOk' : ''}>
                 <td>Dapat Diterima (Acceptable)</td>
                 <td>18-24%</td>
                 <td>25-31%</td>
               </tr>
              <tr className={result.bodyFatCategory === 'Obesitas' ? 'highlightedDanger' : ''}>
                 <td>Obesitas (Obese)</td>
                 <td>+ 25%</td>
                 <td>+ 32%</td>
               </tr>
              <tr>
                <td colSpan="3">
                  <b>Sumber:</b>{' '}
                  <a href="https://www.acefitness.org/resources/everyone/tools-calculators/percent-body-fat-calculator/">
                    American Council on Exercise
                  </a>
                 </td>
               </tr>
               <tr>
                <td colSpan="3">
                  <b>Tanggal Peninjauan Terakhir:</b> 28/02/2026
                 </td>
               </tr>
            </tbody>
          </table>
        </div>
        <br />
    </div>
  );
}
export default BodyFatTable;
